import useRatingStore from "../ratingStore.js";

// Interactive objects actions
export const interactiveActions = (set) => ({
  setInteractiveObjects: (chartId, objectsMap, chartSectionId = null) => {
    const key = chartSectionId ? `${chartId}_${chartSectionId}` : chartId;
    set((state) => ({
      charts: state.charts.map((chart) =>
        chart.id === chartId
          ? {
              ...chart,
              interactiveObjects: {
                ...chart.interactiveObjects,
                [key]: objectsMap,
              },
            }
          : chart,
      ),
    }));
  },

  updateInteractiveObjects: (
    chartId,
    objectType,
    objects,
    chartSectionId = null,
  ) => {
    const key = chartSectionId ? `${chartId}_${chartSectionId}` : chartId;
    set((state) => ({
      charts: state.charts.map((chart) =>
        chart.id === chartId
          ? {
              ...chart,
              interactiveObjects: {
                ...chart.interactiveObjects,
                [key]: {
                  ...chart.interactiveObjects?.[key],
                  [objectType]: objects,
                },
              },
            }
          : chart,
      ),
    }));
  },

  setActiveInteractive: (chartId, interactiveType, opts = {}) => {
    set((state) => ({
      activeInteractiveTools: {
        ...state.activeInteractiveTools,
        [chartId]: interactiveType,
      },
    }));
    // Engagement trigger — only when ARMING a tool (truthy), not disarming (null), and
    // not for programmatic arms (transfer-on-hover / WhatsNew CTA) via opts.skipEngagement.
    if (interactiveType && !opts.skipEngagement) {
      useRatingStore.getState().registerEngagement();
    }
  },

  deleteInteractiveObject: (
    chartId,
    chartSectionId,
    objectType,
    objectIndex,
  ) => {
    const key = chartSectionId ? `${chartId}_${chartSectionId}` : chartId;
    set((state) => ({
      charts: state.charts.map((chart) =>
        chart.id === chartId
          ? {
              ...chart,
              interactiveObjects: {
                ...chart.interactiveObjects,
                [key]: {
                  ...chart.interactiveObjects[key],
                  [objectType]: (
                    chart.interactiveObjects[key]?.[objectType] || []
                  ).filter((_, index) => index !== objectIndex),
                },
              },
            }
          : chart,
      ),
    }));
  },

  updateInteractiveObjectAppearance: (
    chartId,
    chartSectionId,
    objectType,
    objectIndex,
    updatedAppearance,
  ) => {
    // Convert string IDs to numbers for consistent comparison
    const numericChartId =
      typeof chartId === "string"
        ? chartId.match(/^[0-9]+$/)
          ? parseInt(chartId, 10)
          : chartId
        : chartId;
    const numericChartSectionId =
      typeof chartSectionId === "string"
        ? chartSectionId.match(/^[0-9]+$/)
          ? parseInt(chartSectionId, 10)
          : chartSectionId
        : chartSectionId;

    // Key format matches how InteractiveLayer stores objects
    const key = numericChartSectionId
      ? `${numericChartId}_${numericChartSectionId}`
      : numericChartId;

    set((state) => ({
      charts: state.charts.map((chart) =>
        chart.id === numericChartId
          ? {
              ...chart,
              interactiveObjects: {
                ...chart.interactiveObjects,
                [key]: {
                  ...chart.interactiveObjects[key],
                  [objectType]: (
                    chart.interactiveObjects[key]?.[objectType] || []
                  ).map((obj, index) =>
                    index === objectIndex
                      ? { ...obj, appearance: updatedAppearance } // No transformation - store registry format as-is
                      : obj,
                  ),
                },
              },
            }
          : chart,
      ),
    }));
  },
});
